import { render, staticRenderFns } from "./Admissions.vue?vue&type=template&id=61452d2b&scoped=true&"
import script from "./Admissions.vue?vue&type=script&lang=js&"
export * from "./Admissions.vue?vue&type=script&lang=js&"
import style0 from "./Admissions.vue?vue&type=style&index=0&id=61452d2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61452d2b",
  null
  
)

export default component.exports